/* eslint-disable no-useless-escape */
import variables from '../config/_variables';
import auth from './_modules/auth';
import images from './_modules/images';
import validation from './_modules/validation';
import parser from './_modules/parser';
import translator from './_modules/translator';
// import wordpress from './_modules/wordpress';

export default {
	mixins: [auth, images, validation, parser, translator/* , wordpress */],
	data() {
		return {
			vars: variables,
		};
	},
};
